export default "__VITE_ASSET__CKD3mk98__"